var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3288 8.71263C17.1774 4.24332 13.5065 0.666656 9.00033 0.666656C4.39795 0.666656 0.666992 4.39762 0.666992 8.99999C0.666992 13.5062 4.24365 17.177 8.71297 17.3285V17.3333L17.3337 17.3333V8.71263H17.3288ZM16.1842 16.1839L8.71297 16.1839V16.1783C4.87862 16.0274 1.81642 12.8713 1.81642 8.99999C1.81642 5.03243 5.03276 1.81608 9.00033 1.81608C12.8716 1.81608 16.0278 4.87829 16.1786 8.71263H16.1842L16.1842 16.1839ZM12.1796 8.7349L4.47249 8.7349L4.47248 6.67969L12.1796 6.67969L12.1796 8.7349ZM14.7486 7.70732L12.6934 8.73493L12.6934 6.67969L14.7486 7.70732ZM13.1908 9.69452H13.8613V10.904H13.1908V9.69452ZM4.80958 9.69471L4.13908 9.69471V10.904L4.80958 10.904L4.80958 9.69471ZM13.8613 11.7701L4.13908 11.7701V12.5802L13.8613 12.5802L13.8613 11.7701ZM9.16781 9.69452H8.83257V10.904H9.16781V9.69452ZM5.48007 10.3892H5.81532L5.81532 10.904H5.48007L5.48007 10.3892ZM6.82107 10.3892H6.48582L6.48582 10.904H6.82107L6.82107 10.3892ZM7.49157 10.3892H7.82682L7.82682 10.904H7.49157L7.49157 10.3892ZM10.5088 10.3892H10.1736V10.904H10.5088V10.3892ZM11.1793 10.3892H11.5146V10.904H11.1793V10.3892ZM12.5203 10.3892H12.1851V10.904H12.5203V10.3892Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageTools);
export default __webpack_public_path__ + "static/media/ImageTools.c5bd86d5bdc390cefde8a5b62cc4d66a.svg";
export { ForwardRef as ReactComponent };